export default __webpack_public_path__ + "static/media/rat_inc_icon.70ef57dd.png";